var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassObject", {
    attrs: {
      object: _vm.object,
      size: "extra-small",
      label: _vm.titleTypeActivity,
      variant: "on-color"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }